import React, {useCallback, useState} from 'react';
import {Button, Col, Row} from 'reactstrap';

import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent.js';

export default function ModalExitScreening(props) {
  const {isOpen, toggle} = useExitIntent(300000);
  return (
    <Modal className="modal-exit-intent modal-exit-intent-screening" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          <h4 className="section-heading mb-4">Hold up!</h4>
          <p>Once you click away, this discount disappears.</p>
          <p>
            Now’s the BEST time to get the <i>Plant-Powered Playbook</i> while it’s 66% off.
          </p>
          <Button className="btn-exit text-uppercase text-white text-h6" color="cta" onClick={toggle} block>
            Get the <br />
            <i>Plant-Powered Playbook</i>
          </Button>
        </Col>
        <Col xs="12" lg="5" className="exit-modal-image-col order-lg-1">
          <div
            className="exit-modal-image"
            style={{backgroundImage: `url('${require('static/backgrounds/1357522236-exit.jpg')}')`}}
          />
        </Col>
      </Row>
    </Modal>
  );
}
